module.exports = {
  direct: 'direct',
  indirect: 'indirect',
  none: 'none'
};
